import React, { Suspense, useEffect } from 'react';
import { Route, Switch, Redirect, useLocation, useHistory } from 'react-router-dom';
import { CContainer } from '@coreui/react';
import { useSelector, useDispatch } from 'react-redux';
import isObject from 'lodash/isObject';

// routes config
import { defaultSubscriberRoutes } from '../../routes';
import CreateAccount from '../../components/cms/subscriber/account/create-account/CreateAccount';
import UpgradeAccount from '../../components/cms/subscriber/account/upgrade-account/UpgradeAccount';
import BlockAccount from '../../components/cms/subscriber/account/block-account/BlockAccount';
import BreadcrumbRouter from '../../components/general/breadcrumb/BreadcrumbRouter';
import { TermAndConditionPopup } from '../../components/general/popup';
import CenterSpinner from '../../components/general/Loadings/CenterSpinner';
import AccountDormant from '../../components/cms/subscriber/account/account-dormant/AccountDormant';
import CFade from '../../components/migration/CFade';
import CSubheader from '../../components/migration/CSubheader';
import { setFlexibleModal } from '../../actions/common.js';
import { selectSubscriberRoutes } from '../../store-selectors';

const SubscriberContent = () => {
     const routes = useSelector(selectSubscriberRoutes);
     const location = useLocation();
     const dispatch = useDispatch();
     const history = useHistory();
     const accountExternalData = useSelector((state) => state.subscriber.accountExternalData);
     const accountExternalSources =
          accountExternalData?.sources && accountExternalData.sources.length > 0 && accountExternalData.sources;
     const lastSegment = location.pathname.substring(location.pathname.lastIndexOf('/') + 1);

     useEffect(() => {
          const routeExternalData =
               (accountExternalSources &&
                    accountExternalSources
                         .filter((i) => i.accountExternalData && i.accountExternalData.status)
                         .map((item) => {
                              return item.alias;
                         })) ||
               [];

          if (
               accountExternalSources &&
               accountExternalSources.map((i) => i.alias).includes(lastSegment) &&
               !routeExternalData.includes(lastSegment) &&
               window.location.pathname.includes('external-data')
          ) {
               history.push(`/${activeAccount.secondId}`);
               dispatch(setFlexibleModal({ show: false, component: '' }));
          }
     }, [accountExternalData.sources]); //eslint-disable-line

     const activeAccount = useSelector((state) => state.subscriber.activeAccount);
     const accountsLoading = useSelector((state) => state.subscriber.loadings.accounts);
     const user = useSelector((state) => state.theme.user);
     const listenersLoading = useSelector((state) => state.subscriber.loadings.listeners);
     const accountLoading = useSelector((state) => state.subscriber.loadings.account);
     const gtmTokenLoading = useSelector((state) => state.subscriber.loadings.gtmToken);
     const customExternalObjectReportLoading = useSelector((state) => state.subscriber.loadings.customExternalObjectReport);
     const externalObjectReportLoading = useSelector((state) => state.subscriber.loadings.externalObjectReport);

     return (
          <main className="c-main">
               <CSubheader className="main-breadcrumb justify-content-between">
                    <BreadcrumbRouter className="border-0 c-subheader-nav m-0 px-4 px-md-3 d-flex align-items-center" routes={routes} />
               </CSubheader>
               <CContainer fluid className={location.pathname === `/${activeAccount?.secondId}/dashboard` ? 'container-dashboard' : ''}>
                    {accountsLoading || listenersLoading || accountLoading || gtmTokenLoading || customExternalObjectReportLoading || externalObjectReportLoading ? (
                         <CenterSpinner />
                    ) : (
                         <Suspense fallback={<CenterSpinner />}>
                              <Switch>
                                   {routes.map((route, idx) => {
                                        return (
                                             route.component && (
                                                  <Route
                                                       key={route.path}
                                                       path={route.path}
                                                       exact={route.exact}
                                                       name={route.name}
                                                       render={(props) => {
                                                            const finalProps = isObject(route.props) ? { ...props, ...route.props } : { ...props };

                                                            return (
                                                                 <CFade>
                                                                      <route.component {...finalProps} />
                                                                 </CFade>
                                                            );
                                                       }}
                                                  />
                                             )
                                        );
                                   })}
                                   {routes.length >= defaultSubscriberRoutes.length && <Redirect to={`/${activeAccount.secondId}`} />}
                              </Switch>
                              <CreateAccount />
                              <UpgradeAccount />

                              <AccountDormant />
                              {!user.registerMasterClass && <BlockAccount />}
                              <TermAndConditionPopup />
                         </Suspense>
                    )}
               </CContainer>
          </main>
     );
};

export default React.memo(SubscriberContent);
